// extracted by mini-css-extract-plugin
export default {"title":"NNzvB","subRatingTitle":"HsBiz","subRating":"cnock","titleRow":"GYl4f","icon":"jm_NI"};